export default function AboutExpertise() {
  return (
    <section className="w-full py-20 md:py-28" style={{ backgroundColor: '#F5F0E6' }}>
      <div className="max-w-[1440px] mx-auto px-8 md:px-16">
        <p className="text-sm font-medium tracking-[0.12em] uppercase text-foreground-500 mb-8">
          About the team
        </p>

        <p className="text-xl md:text-2xl text-foreground-700 leading-relaxed max-w-[680px]">
          We build scalable, maintainable, and high-performance systems with a strong focus on usability, stability, and long-term technical quality. The team follows modern software engineering practices, including clean architecture, performance optimization, and user-centered design.
        </p>
      </div>
    </section>
  );
}